var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-background"},[_c('section',{staticClass:"layout-main"},[_c('div',{staticClass:"layout-content"},[_c('div',{staticClass:"inner-content"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }